import { useEffect, useState } from 'react';

import { useJsApiLoader } from '@react-google-maps/api';
import { Spin } from 'antd';
import { useParams } from 'react-router-dom';

import PathPointForm from './path-point-form';

import type PathType from '../../../../typings/map/PathType';

import pathsService from '../../../../services/map/paths-service';
import TitledCard from '../../../layout-components/titled-card';

const NewPathPoint: React.FC = () => {
  const [loading, setLoading] = useState(false);
  const [path, setPath] = useState<PathType>();

  const params = useParams();
  const pathId = Number(params.pathId);

  const { isLoaded } = useJsApiLoader({
    id: 'google-map-script',
    googleMapsApiKey: process.env.REACT_APP_GOOGLE_MAPS_KEY ?? '',
  });

  useEffect(() => {
    setLoading(true);
    pathsService.getPath(pathId).then((response) => {
      setPath(response.path);
      setLoading(false);
    });
  }, [pathId]);

  return (
    <Spin spinning={loading}>
      <TitledCard
        title={`Ścieżka zwiedzania ${path?.name_pl} » Nowy punkt zwiedzania`}
        backUrl=".."
      >
        {path && isLoaded ? <PathPointForm pathId={pathId} setLoading={setLoading} /> : null}
      </TitledCard>
    </Spin>
  );
};
export default NewPathPoint;
